package com.devi3east.bashbuddy.features.events.common.data.models

import kotlinx.datetime.Instant
import kotlinx.serialization.Serializable

@Serializable
data class Ticket(
    val _id: String = "",
    val title: String? = null,
    val description: String? = null,
    val createdAtInstant: Instant? = null,
    val createdById: String? = null,
    val createdByName: String? = null,
    val status: TicketStatus = TicketStatus.UPCOMING,
    val ticketType: TicketType = TicketType.DIGITAL,
    val raffleType: RaffleType = RaffleType.MAIN_RAFFLE,
    val cutOffTimeInstant: Instant? = null,
    val isFiftyFifty: Boolean = false,
    val imageUrl: String? = null,
    val eventId: String? = null,
    val eventTitle: String? = null,
    val serialNumber: String? = null,
    val chancesPerTicket: Int? = null,
    val maxQuantity: Int? = null,
    val availableQuantity: Int? = null,
    val donation: Long = 0L,
    val shippingFee: Long = 0L,
    val revenue: Long = 0L,
    val ticketsSold: Int = 0,
    val maxChanceNumber: Int? = null,
    val pendingActions: Int = 0,
    val purchaseAge: Int? = null
)